export default __webpack_public_path__ + "static/mainfeatureai2-032b30c8736031664da1cad49fead39a.svg";